module.exports = __webpack_public_path__ + "static/img/lvcha.95f437ba.png";